// extracted by mini-css-extract-plugin
export default {"container":"Resultado_container__Q9gJg","conteudo":"Resultado_conteudo__vHPeW","bt":"Resultado_bt__O0MNV"};